export const ALLOWED_LOCALES = [
  'en',
  'de',
  'pt-BR',
  'es',
  'it',
  'fr',
  'ja',
  'zh-Hant',
  'zh-Hans',
  'da',
  'fi',
  'nl',
  'pl',
  'ru',
  'sv',
  'cs',
  'hi',
  'ko',
  'nb',
  'th'
];

export const I18N_COOKIE_KEY = 'webapp_i18nextLng';
